import { format } from 'date-fns';
import { groupBy } from 'lodash';

import { CALENDAR_PIPE } from '@modules/shared/CalendarComponent';

export const processBigCalendarTimeSlots = (dateAndTime: any) => {
  const groupedDateTime = groupBy(dateAndTime, 'date');
  let startTimeSlots: any[] = [];

  Object.entries(groupedDateTime).map((entry) => {
    const date = new Date(entry[0]);
    const slots = (entry[1] as [])?.map((timeSlot: any) => {
      return +timeSlot.id.split(CALENDAR_PIPE)[1];
    });
    startTimeSlots.push({
      date: format(date, 'yyyy-MM-dd'),
      slots,
    });
  });
  return startTimeSlots;
};
